var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcon4 = function SvgIcon4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#2E34D5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.28 15.2a1.24 1.24 0 0 0-.55-.53 1.7 1.7 0 0 0-.83-.19q-.83 0-1.33.55-.5.54-.5 1.45 0 .97.52 1.52.53.54 1.45.54.63 0 1.06-.32.44-.32.64-.92h-2.17v-1.26h3.72v1.59a3.3 3.3 0 0 1-.65 1.19q-.45.55-1.15.89a3.6 3.6 0 0 1-1.58.34q-1.04 0-1.86-.45a3.3 3.3 0 0 1-1.27-1.27q-.45-.81-.45-1.85t.45-1.85q.46-.82 1.27-1.27.81-.46 1.85-.46 1.26 0 2.12.61.87.61 1.15 1.69zm8.307.04q0 .61-.28 1.12-.28.5-.86.81-.579.31-1.44.31h-1.06V20h-1.71v-7.02h2.77q.84 0 1.42.29t.87.8.29 1.17m-2.71.88q.49 0 .73-.23t.24-.65-.24-.65-.73-.23h-.93v1.76zm8.65-3.14v1.37h-1.86V20h-1.71v-5.65h-1.86v-1.37z"
  })));
};
export default SvgIcon4;